var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('api-loader',{attrs:{"method":"get","url":"v1/sales/egg-orders"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var result = ref.result;
return (result)?_c('b-card',{attrs:{"no-body":""}},[_c('egg-orders',{attrs:{"orders":result}})],1):_vm._e()}}],null,true)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9dfdcf4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sales/views/EggOrdersView.vue
// module id = null
// module chunks = 